import classNames from 'classnames';
import PropTypes from 'prop-types';

import * as AppPropTypes from '../../lib/PropTypes';

import { useThemeClassName } from '../../contexts/ThemeContext';
import Menu from '../menus/Menu';

import styles from '../../../styles/partials/footer-default.module.scss';

const propTypes = {
    className: PropTypes.string,
    menuItems: AppPropTypes.menuItems,
};

function FooterDefault({ className = null, menuItems = null }) {
    const themeClassName = useThemeClassName(styles);

    return (menuItems || []).length > 0 ? (
        <footer
            className={classNames([
                styles.container,
                {
                    [themeClassName]: themeClassName !== null,
                    [className]: className !== null,
                },
            ])}
        >
            <Menu
                items={menuItems}
                itemActiveClassName={styles.itemActive}
                itemsClassName={styles.items}
                itemClassName={styles.item}
                className={styles.menu}
            />
        </footer>
    ) : null;
}

FooterDefault.propTypes = propTypes;

export default FooterDefault;
